import { filterObjectFromWhiteList } from 'services/Formats';
import {isEmpty} from "lodash";

const REQUIRED_ADDRESS_FIELDS = [
  'contactId',
  'typeId',
  'addressLines',
  'attention',
  'city',
  'state',
  'zipCode',
  'zipCodeExt',
  'country',
  'poBoxNumber',
  'foreign',
  'effectiveDate',
  'expirationDate',
  'accountDescriptors'
];

const REQUIRED_VALIDATED_ADDRESS_FIELDS = [
  'addressLines',
  'city',
  'state',
  'zipCode',
  'zipCodeExt'
];

export const getStandardizedAddress = (address) => {
  return filterObjectFromWhiteList(address, REQUIRED_ADDRESS_FIELDS)
};

export const getRequiredAddressValidationFieldsEmpty = (address) => {
  if(isEmpty(address)) {
    return true;
  }
  const filteredRequiredFields = filterObjectFromWhiteList(address, REQUIRED_VALIDATED_ADDRESS_FIELDS);
  return Object.keys(filteredRequiredFields).some(key => isEmpty(address[key]));
};

export const buildAddressesToValidate = (mailingAddress, residentialAddress, isMailingSameAsResidential) => {
  let addresses = [];
  if(isMailingSameAsResidential) {
    if(!residentialAddress.foreign) {
      addresses.push(residentialAddress);
    }
  } else {
    if(!mailingAddress.foreign) {
      addresses.push(mailingAddress)
    }

    if(!residentialAddress.foreign) {
      addresses.push(residentialAddress)
    }
  }

  return addresses;
};